import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  TextField,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ClearIcon from "@mui/icons-material/Clear";

const CreditNoteInvoiceItemGroup = ({
  selectedInvoices,
  invoices,
  editableItems,
  onEdit,
  onRemove,
}) =>
  selectedInvoices.map((invId) => {
    const invoice = invoices.find((inv) => inv.id === invId);
    const items = editableItems.filter((i) => i.invoice_id === invId);
    if (items.length === 0) return null;
    return (
      <Accordion key={invId} defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight="bold">
            Invoice #{invoice?.invoice_number}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {items.map((item) => (
            <Box
              key={item.id}
              display="flex"
              flexDirection="column"
              gap={1}
              mb={2}
              p={2}
              border="1px solid #ddd"
              borderRadius={2}
              position="relative"
            >
              <IconButton
                size="small"
                onClick={() => onRemove(item.id)}
                sx={{ position: "absolute", top: 8, right: 8 }}
              >
                <ClearIcon />
              </IconButton>

              <Typography>
                <strong>{item.product_name}</strong> (HSN: {item.hsn})
              </Typography>
              <Box display="flex" gap={2}>
                <TextField
                  label="Returned Quantity"
                  type="number"
                  inputProps={{
                    max: item.quantity,
                    min: 0,
                    step: item.unit === "pcs" ? 1 : 0.01,
                  }}
                  value={item.returned_quantity}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (value === "") return;

                    value = parseFloat(value);

                    if (value > item.quantity) return;

                    if (item.unit === "pcs") {
                      if (!Number.isInteger(value)) return;
                    } else if (item.unit === "meters") {
                      const decimalPart = value.toString().split(".")[1];
                      if (decimalPart && decimalPart.length > 2) return;
                    }

                    onEdit(item.id, "returned_quantity", value);
                  }}
                  helperText={`Max: ${item.quantity} ${item.unit}`}
                />

                <TextField
                  label="Returned Item Unit"
                  type="text"
                  value={item.unit}
                  disabled
                />
                <TextField
                  label="Item Rate"
                  type="number"
                  value={item.rate}
                  disabled
                />
                <TextField
                  label="Item Discount"
                  type="number"
                  value={(
                    ((item.discount / (item.quantity * item.rate)) * 100 *
                      item.returned_quantity *
                      item.rate) /
                    100
                  ).toFixed(2)}
                  disabled
                  helperText={`Discount: ${
                    item.quantity && item.rate
                      ? (
                          (item.discount / (item.quantity * item.rate)) *
                          100
                        ).toFixed(2)
                      : "0.00"
                  }%`}
                />
              </Box>
            </Box>
          ))}
        </AccordionDetails>
      </Accordion>
    );
  });

export default CreditNoteInvoiceItemGroup;
